var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-dialog',{staticClass:"add-container",attrs:{"title":_vm.titleName,"width":_vm.dialogWidth,"modal-append-to-body":"","append-to-body":"","visible":_vm.showDialog},on:{"close":_vm.closeDialog}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }